const post = (obj) => {
  try {
    if (window.FlutterChannel && window.FlutterChannel.postMessage) {
      window.FlutterChannel.postMessage(JSON.stringify(obj));
      return true;
    }
  } catch {}
  return false;
};

export const isApp = () =>
  !!(window.FlutterChannel && window.FlutterChannel.postMessage);

export const notifyLogin = () => {
  const token = localStorage.getItem("token");
  if (!token) return;
  let user = null;
  try {
    user = JSON.parse(localStorage.getItem("user") || "null");
  } catch {}
  post({ type: "LOGGED_IN", token, user });
};

export const notifyLogout = () => post({ type: "LOGGED_OUT" });

export const saveInApp = (blob, name) =>
  new Promise((resolve) => {
    if (!isApp()) return resolve(false);
    const r = new FileReader();
    r.onload = () =>
      resolve(
        post({
          type: "SAVE_FILE",
          name,
          base64: String(r.result).split(",")[1] || "",
        }),
      );
    r.onerror = () => resolve(false);
    r.readAsDataURL(blob);
  });
